module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead0-ecb93232f73e93e563acd2ff07215908.jpg";